<template>
	<div class="ClientesNuevo">
		<md-layout md-flex="100" md-align="center">
			<md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="90" md-flex-large="80" md-flex-xlarge="70">
				<md-card class="w-100">
					<md-card-header>
						<div class="md-title">Registrar cliente</div>
						<div class="md-subhead">Los campos marcados con * son obligatorios</div>
					</md-card-header>
					<md-card-content>
						<md-layout md-flex="100" md-align="center" md-gutter="24">
							<md-layout md-flex-xsmall="70" md-flex-small="70" md-flex-medium="70" md-flex-large="70" md-flex-xlarge="70">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_nombre }">
									<label>Razón social</label>
									<md-input v-model="cliente.nombre" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="30" md-flex-small="30" md-flex-medium="30" md-flex-large="30" md-flex-xlarge="30">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_cuenta }">
									<label>Cuenta</label>
									<md-input v-model="cliente.cuenta" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="33" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
								<md-input-container>
									<label>R.F.C.</label>
									<md-input v-model="cliente.rfc"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="33" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
								<md-input-container>
									<label>Email</label>
									<md-input v-model="cliente.email" type="email"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="33" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
								<md-input-container>
									<label>Teléfono</label>
									<md-input v-model="cliente.telefono" v-mask="'(###) ###-#####'"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="70" md-flex-small="70" md-flex-medium="35" md-flex-large="35" md-flex-xlarge="35">
								<md-input-container>
									<label>Calle</label>
									<md-input v-model="cliente.calle"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="30" md-flex-small="30" md-flex-medium="15" md-flex-large="15" md-flex-xlarge="15">
								<md-input-container>
									<label># ext</label>
									<md-input v-model="cliente.numero"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="70" md-flex-small="70" md-flex-medium="35" md-flex-large="35" md-flex-xlarge="35">
								<md-input-container>
									<label>Colonia</label>
									<md-input v-model="cliente.colonia"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="30" md-flex-small="30" md-flex-medium="15" md-flex-large="15" md-flex-xlarge="15">
								<md-input-container>
									<label>C. P.</label>
									<md-input v-model="cliente.codigo_postal"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="40" md-flex-medium="40" md-flex-large="40" md-flex-xlarge="40">
								<md-input-container>
									<label>Municipio</label>
									<md-input v-model="cliente.municipio"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="40" md-flex-medium="40" md-flex-large="40" md-flex-xlarge="40">
								<md-input-container>
									<label>Estado</label>
									<md-input v-model="cliente.estado"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="20" md-flex-small="20" md-flex-medium="20" md-flex-large="20" md-flex-xlarge="20">
								<md-input-container>
									<label for="ruta">Ruta</label>
									<md-select name="ruta" id="ruta" v-model="cliente.ruta">
										<md-option value="centro">Centro</md-option>
										<md-option value="norte">Norte</md-option>
										<md-option value="sur">Sur</md-option>
									</md-select>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="100" md-flex-large="100" md-flex-xlarge="100">
								<md-input-container>
									<md-icon>edit</md-icon>
									<label>Notas</label>
									<md-textarea v-model="cliente.notas"></md-textarea>
								</md-input-container>
							</md-layout>
						</md-layout>
					</md-card-content>
					<md-card-actions>
						<router-link tag="md-button" to="/clientes">Cancelar</router-link>
						<md-button class="md-raised md-primary" @click.native="guardarCliente()">Guardar cliente</md-button>
					</md-card-actions>
				</md-card>
			</md-layout>
		</md-layout>
	</div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
export default {
  name: "ClientesNuevo",
  methods: {
    guardarCliente() {
      if (this.validarCamposCliente()) {
        this.$http
          .post("clientes/guardar", {
            token: this.$session.get("token"),
            data: this.cliente
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                Snackbar.show({
                  text: response.body.msg,
                  actionText: "Cerrar",
                  pos: "top-right",
                  showAction: false
                });
                this.$router.push("/clientes");
              } else {
                Snackbar.show({
                  text: response.body.error,
                  actionText: "Cerrar",
                  pos: "top-right",
                  showAction: false,
                  backgroundColor: "#F44336",
                  actionTextColor: "#FFF"
                });
              }
            },
            response => {
              Snackbar.show({
                text: "No se pudo establecer conexión con el servidor.",
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          );
      }
    },
    validarCamposCliente() {
      !this.cliente.nombre
        ? (this.val.v_nombre = true)
        : (this.val.v_nombre = false);
      !this.cliente.cuenta
        ? (this.val.v_cuenta = true)
        : (this.val.v_cuenta = false);
      if (this.val.v_nombre || this.val.v_cuenta) {
        Snackbar.show({
          text: "Por favor llene todos los campos marcados con *",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  data() {
    return {
      cliente: {
        cuenta: null,
        nombre: null,
        rfc: null,
        email: null,
        telefono: null,
        estado: null,
        municipio: null,
        ciudad: null,
        calle: null,
        colonia: null,
        numero: null,
        codigo_postal: null,
        fecha_ingreso: null,
        notas: null,
        ruta: null
      },
      val: {
        v_cuenta: null,
        v_nombre: null
      }
    };
  }
};
</script>


// WEBPACK FOOTER //
// ClientesNuevo.vue?31013914